import apiClient from "@/app/api/client";
import type { ListParams } from "@/shared/types/api";

export const snapshotService = {
	list(params?: ListParams) {
		return apiClient.get("/snapshots", { params }).then((r) => r.data);
	},
	get(id: number) {
		return apiClient.get(`/snapshots/${id}`).then((r) => r.data);
	},
};
